import { z } from 'zod';
/** Adapter commission embedded in S3 `manifest.json` (set by cloud on config push). */
export const GatewayManifestAdapterAssignmentSchema = z.object({
    adapterKey: z.string().min(1).max(64),
    gatewayType: z.enum(['efem', 'location']),
});
export function adapterAssignmentForManifest(gatewayType, adapterKey) {
    const key = adapterKey?.trim();
    if (!key)
        return undefined;
    return GatewayManifestAdapterAssignmentSchema.parse({ adapterKey: key, gatewayType });
}
export function readAdapterAssignmentFromManifest(manifest, expectedGatewayType) {
    const raw = manifest.adapterAssignment;
    if (!raw)
        return null;
    const parsed = GatewayManifestAdapterAssignmentSchema.parse(raw);
    if (parsed.gatewayType !== expectedGatewayType)
        return null;
    return parsed;
}
//# sourceMappingURL=gateway-manifest-adapter-assignment.js.map